import React from 'react';

/**
 * Audio Component
 * @param  {Object} props The passed in props
 * @return {JSX} Audio Component
 */
const Audio = ({tabIndex, type, url}) => (
  <audio controls tabIndex={tabIndex}>
    <source src={url} type={type} />
    Your browser does not support the audio element.
  </audio>
);

Audio.propTypes = {
  tabIndex: React.PropTypes.string,
  type: React.PropTypes.string,
  url: React.PropTypes.string.isRequired,
};

Audio.defaultProps = {
  tabIndex: '0',
  type: 'audio/mpeg',
};

export default Audio;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Audio/Audio.js